// extracted by css-extract-rspack-plugin
export default {"cls1":"WhoCanSeePost-cls1_QJj","cls2":"WhoCanSeePost-cls2_Uv- WhoCanSeePost-cls1_QJj"};